export class Constants {
    public static IsSanbox = false;

    public static SETTINGS_NUMBER = "SETTINGS_NUMBER"
    public static SETTINGS_PHONE_NUMBER = "SETTINGS_PHONE_NUMBER"
    public static SETTINGS_LATEST_REQUEST = "SETTINGS_LATEST_REQUEST"
    public static SETTINGS_REQUEST_TYPE = "SETTINGS_REQUEST_TYPE"
    public static SETTINGS_CURRENT_REQUESTED_KEY = "SETTINGS_CURRENT_REQUESTED_KEY"
    public static SETTINGS_SMS_PLAYLIST = "SETTINGS_SMS_PLAYLIST"
    public static SETTINGS_FIRST_TIME = "SETTINGS_FIRST_TIME"
    public static SETTINGS_PREMIUM_PHONE = "SETTINGS_PREMIUM_PHONE"
    public static SETTINGS_UUID = "SETTINGS_UUID"
    public static SETTINGS_LAT = "lat"
    public static SETTINGS_LNG = "lng"
    public static SETTINGS_ADDRESS = "address"
    public static SETTINGS_PLACEID = "placeId"
    public static SETTINGS_SPOTIFY_PLAYLISTID = "SETTINGS_SPOTIFY_PLAYLISTID"

    public static EVENT_KEY = "EVENT_KEY"
    public static EVENT_NAME = "EVENT_NAME"
    public static EVENT_UID = "EVENT_UID"
    public static EVENT_DJEMAIL = "EVENT_DJEMAIL"
    public static EVENT_DJNAME = "EVENT_DJNAME"
    public static EVENT_PROFILE_URL = "EVENT_PROFILE_URL"
    public static EVENT_VENUE = "EVENT_VENUE"
    public static EVENT_IS_KARAOKE = "EVENT_IS_KARAOKE"
    public static EVENT_IS_TIPPING = "EVENT_IS_TIPPING"
    public static EVENT_IS_COLLECTS_EMAILS = "EVENT_IS_COLLECTS_EMAILS"
    public static EVENT_IS_COLLECTS_PHONE_NUMBERS = "EVENT_IS_COLLECTS_PHONE_NUMBERS"

    public static EVENT_BUS_WRONG_LOCATION = "EVENT_BUS_WRONG_LOCATION"
    public static EVENT_BUS_SHOUTOUT = "EVENT_BUS_SHOUTOUT"
    public static EVENT_BUS_TIPPING= "EVENT_BUS_TIPPING"
    public static EVENT_BUS_MENU = "EVENT_BUS_MENU"
    public static EVENT_UPDATE_SPOIFY_PLAYLIST = "EVENT_UPDATE_SPOIFY_PLAYLIST"

    public static REQUEST_TYPE_SONG_REQUEST = "REQUEST_TYPE_SONG_REQUEST"
    public static REQUEST_TYPE_UPVOTE = "REQUEST_TYPE_UPVOTE"

    public static UPVOTE_TYPE_SONG = "UPVOTE_TYPE_SONG"
    public static UPVOTE_TYPE_PERFORMANCE = "UPVOTE_TYPE_PERFORMANCE"
}